'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _certificates = require('./certificates.html');

var _certificates2 = _interopRequireDefault(_certificates);

var _certificates3 = require('./certificates.controller');

var _certificates4 = _interopRequireDefault(_certificates3);

require('./certificates.styl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var certificatesComponent = {
  restrict: 'E',
  bindings: {},
  template: _certificates2.default,
  controller: _certificates4.default,
  controllerAs: 'vm'
};

exports.default = certificatesComponent;


/** WEBPACK FOOTER **
 ** ./client/app/containers/certificates/certificates.component.js
 **/